import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { TypographyColor, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';

@Component({
  selector: 'app-ds-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
  ]
})
export class DataDsComponent {

  @Input() data: string | number;
  @Input() fontSize = TypographyFontSize.Minor;
  @Input() isDisabled = false;

  constructor() { }

  get fontColor(): TypographyColor {
    return this.isDisabled ? TypographyColor.Disabled : TypographyColor.Secondary;
  }

}
